import {
	Conversation,
	ConversationNode,
	ConversationNodeType,
	Dialog,
	INodeConfig,
	Path
} from "@/views/conversation-builder/conversation-builder.model";
import * as d3 from "d3";
import { v4 } from "uuid";

// Connector
export const connectorPathGenerator = d3
	.linkVertical<{ source: [number, number]; target: [number, number] }, any>()
	.source((d) => d.source)
	.target((d) => d.target)
	.x((d) => d[0])
	.y((d) => d[1]);

export const nodeTransformAttr = (node: ConversationNode) => {
	return d3.zoomIdentity.translate(node.coords.x, node.coords.y) as any;
};

export const nodeIdAttr = (node: ConversationNode) => node.id;
export const nodeKeyAttr = (node: ConversationNode) => node.key;

export const DialogConfig: INodeConfig = {
	width: 200,
	height: 50
};
export const PathConfig: INodeConfig = {
	width: 140,
	height: 100
};
export const ConversationConfig: INodeConfig = {
	width: 60,
	height: 60
};

export const nodeConfig: {
	[key in ConversationNodeType]: INodeConfig;
} = {
	[ConversationNodeType.Conversation]: ConversationConfig,
	[ConversationNodeType.Dialog]: DialogConfig,
	[ConversationNodeType.Path]: PathConfig,
	[ConversationNodeType.ExternalConversation]: DialogConfig,
	[ConversationNodeType.Connector]: DialogConfig
};
export class SVGStateHandler {
	private timeout: NodeJS.Timeout | undefined;

	constructor(private readonly svg: d3.Selection<SVGSVGElement, any, HTMLElement, any>) {}

	public dragStart() {
		if (this.timeout) {
			clearTimeout(this.timeout);
			this.timeout = undefined;
		}
		this.svg.classed("cb-ground--dragging", true);
	}
	public dragging() {}

	public dragEnd() {
		this.timeout = setTimeout(() => {
			this.svg.classed("cb-ground--dragging", false);
		}, 500);
	}
}

export function ellipsisNodeTitle(node: ConversationNode<Dialog | Path | Conversation>) {
	let ellipsedText = "";

	if (!node || !node.data || !node.data.name) {
		return ellipsedText;
	}

	const { name } = node.data;

	switch (node.type) {
		case ConversationNodeType.Dialog:
			ellipsedText = name.substring(0, 22);
			break;
		case ConversationNodeType.Path:
			ellipsedText = name.substring(0, 20);
			break;
		case ConversationNodeType.Conversation:
			ellipsedText = name.substring(0, 6);
	}

	if (ellipsedText !== name) {
		return `${ellipsedText}...`;
	}
	return ellipsedText;
}

export interface IRendererActions {
	icon: string;
	eventName: string;
	loading?: boolean;
	disabled?: boolean;
	customClasses?: string[];
}

export function intersects(a: DOMRect, b: DOMRect): boolean {
	return a.right >= b.left && a.left <= b.right && a.bottom >= b.top && a.top <= b.bottom;
}

export function isControlKey(event: MouseEvent | KeyboardEvent): boolean {
	return event?.ctrlKey || event?.metaKey;
}

export function generateNodeId(): string {
	return "_" + v4();
}

export function isControlandAltKey(event: MouseEvent | KeyboardEvent): boolean {
	return (event?.ctrlKey || event?.metaKey) && event?.altKey;
}
